import React from 'react';
import PropTypes from 'prop-types';
import { Radio } from 'antd';

import { FILTER_TYPE } from '../../../data/config/constants'

import CheckboxGroupItem from '../checkboxgroupitem'
import RadioGroupItem from '../radiogroupitem'
import ErrorBoundary from '../../errorboundary'

class RadioGroupWithMultiOptions extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      selected_value_key: props.display_data.defaultValueKey ? props.display_data.defaultValueKey : null
    }
  }

  onChangeRadioGroup = event => {
    const { selected_value_key } = this.state
    const { onChange } = this.props
    onChange(undefined, selected_value_key)
    this.setState({ selected_value_key: event.target.value })
  }

  onChangeCheckbox = selected_value => {
    const { onChange } = this.props;
    const { selected_value_key } = this.state
    onChange(selected_value, selected_value_key)
  }

  onChangeRadio = event => {
    const { onChange } = this.props;
    const { selected_value_key } = this.state
    onChange(event.target.value, selected_value_key)
  }

  renderSelector = () => {
    const { display_data, selected_data } = this.props
    const { selected_value_key } = this.state
    if (display_data.selectors && display_data.selectors[selected_value_key] && display_data.selectors[selected_value_key].type) {
      switch (display_data.selectors[selected_value_key].type) {
        case FILTER_TYPE.CHECKBOX: return (
          <ErrorBoundary>
            <CheckboxGroupItem title={display_data.selectors[selected_value_key].title} options={display_data.selectors[selected_value_key].options} checked_items={selected_data[selected_value_key]} onChange={this.onChangeCheckbox} show_search is_object_type_options />
          </ErrorBoundary>
        )

        case FILTER_TYPE.RADIO: return (
          <ErrorBoundary>
            <RadioGroupItem title={display_data.selectors[selected_value_key].title} options={display_data.selectors[selected_value_key].options} value={selected_data[selected_value_key]} onChange={this.onChangeRadio} show_search />
          </ErrorBoundary>
        )

        default: return null;
      }

    }
  }

  render() {
    const { container_class, display_data } = this.props;
    const { selected_value_key } = this.state;
    return (
      <div className={container_class}>
        <div className="ori-flex-row ori-flex-jc">
          <Radio.Group size="small" value={selected_value_key} onChange={this.onChangeRadioGroup}>
            {
              display_data.radioButtons && display_data.radioButtons.map((btn, index) => {
                return (
                  <Radio.Button key={index} className="ori-font-normal ori-font-13 ori-capitalize-first" value={btn.valueKey}>{btn.label}</Radio.Button>
                );
              })
            }
          </Radio.Group>
        </div>
        {this.renderSelector()}
      </div>
    );
  }
}

RadioGroupWithMultiOptions.propTypes = {
  container_class: PropTypes.string,
  display_data: PropTypes.object,
  selected_data: PropTypes.object,
  onChange: PropTypes.func,
};

RadioGroupWithMultiOptions.defaultProps = {
  container_class: "ori-tb-pad-5",
  display_data: {},
  selected_data: {},
  onChange: () => { },
};

export default RadioGroupWithMultiOptions;



// WEBPACK FOOTER //
// ./src/components/form/radiogroupwithmultioptions/index.js